import type { PublicApiKey } from '@/apilib';
import type { createLayoutApi } from './createLayoutApi';

export const LayoutApiKey: PublicApiKey<typeof createLayoutApi> = {
  name: 'LayoutApi',
  public: true,
};
